var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxCreate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.334H2.5",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 18.3333V12.5",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 18.3333V12.5",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7735 1.66602H6.22711C5.22476 1.66602 4.72358 1.66602 4.32083 1.91493C3.91808 2.16385 3.69394 2.61211 3.24568 3.50864L3.24568 3.50864L2.15781 6.25864C1.83352 7.0784 1.54043 8.08163 2.17309 8.69557C2.47315 8.98675 2.88242 9.16602 3.33359 9.16602C4.25406 9.16602 5.00025 8.41982 5.00025 7.49935C5.00025 8.41982 5.74645 9.16602 6.66692 9.16602C7.58739 9.16602 8.33359 8.41982 8.33359 7.49935C8.33359 8.41982 9.07978 9.16602 10.0003 9.16602C10.9207 9.16602 11.6669 8.41982 11.6669 7.49935C11.6669 8.41982 12.4131 9.16602 13.3336 9.16602C14.2541 9.16602 15.0003 8.41982 15.0003 7.49935C15.0003 8.41982 15.7464 9.16602 16.6669 9.16602C17.1181 9.16602 17.5274 8.98675 17.8275 8.69556C18.4601 8.08163 18.1671 7.0784 17.8428 6.25864L16.7549 3.50864C16.3066 2.61211 16.0825 2.16385 15.6797 1.91493C15.277 1.66602 14.7758 1.66602 13.7735 1.66602Z",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxCreate);
export default __webpack_public_path__ + "static/media/BoxCreate.ec8f68263b6d1ce7f6fb717c6ad9d212.svg";
export { ForwardRef as ReactComponent };